import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useEffect, useRef, useState, } from "react";
import { djRestAuth } from "../api/api";
import { Loading } from "../nav/Loading";
export const UserContext = createContext({
    user: null,
    loading: null,
    setUser: () => undefined,
    setLoading: () => undefined,
});
export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const isVerifying = useRef(false);
    const verifyToken = useCallback(() => {
        if (isVerifying.current)
            return;
        isVerifying.current = true;
        return djRestAuth
            .post("/token/verify/", {})
            .then(() => {
            if (!user) {
                return djRestAuth.get("/user/").then((response) => {
                    setUser(response.data);
                    setLoading(false);
                });
            }
            return Promise.resolve();
        })
            .catch(() => {
            if (!user) {
                return djRestAuth
                    .get("/user/")
                    .then((response) => {
                    setUser(response.data);
                    setLoading(false);
                })
                    .catch(() => {
                    setUser(null);
                    setLoading(false);
                });
            }
            return Promise.resolve();
        })
            .finally(() => {
            isVerifying.current = false;
        });
    }, [user]);
    useEffect(() => {
        if (loading && user === null && !isVerifying.current) {
            verifyToken();
        }
    }, [loading, user, verifyToken]);
    if (loading) {
        return _jsx(Loading, {});
    }
    return (_jsx(UserContext.Provider, { value: { user, loading, setUser, setLoading }, children: children }));
};
